import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { NgbNavModule } from "@ng-bootstrap/ng-bootstrap";
import { TranslateModule } from "@ngx-translate/core";
import { EdpESidebarSubLevelModule } from "./edp-e-sidebar-sub-level/edp-e-sidebar-sub-level.module";
import { EdpESidebarComponent } from "./edp-e-sidebar.component";
import { ExternalLinkModule } from "@edp-directives/external-link/external-link.module";

@NgModule({
  declarations: [EdpESidebarComponent],
  imports: [
    CommonModule,
    TranslateModule,
    NgbNavModule,
    RouterModule,
    EdpESidebarSubLevelModule,
    ExternalLinkModule
  ],
  exports: [EdpESidebarComponent],
})
export class EdpESidebarModule { }
